"use strict";
/**
 * @swagger
 * components:
 *   schemas:
 *     Metadata:
 *       type: object
 *       required:
 *       - documentLink
 *       - fileName
 *       - fileSize
 *       - recordCreatedTimestamp
 *       - recordUpdatedTimestamp
 *       - recordUpdatedUserID
 *       properties:
 *         documentLink:
 *           type: string
 *           maxLength: 500
 *           example: "documentURL.com"
 *         fileName:
 *           type: string
 *           maxLength: 100
 *           example: "Johnny's document"
 *         fileSize:
 *           type: integer
 *           format: int32
 *           example: 114
 *         documentType:
 *           type: string
 *           maxLength: 50
 *           example: "pdf"
 *         description:
 *           type: string
 *           maxLength: 1000
 *           example: "description of document"
 *         recordCreatedTimestamp:
 *           type: string
 *           maxLength: 25
 *           example: "2020-09-01 8:00:00.000000"
 *         recordUpdatedTimestamp:
 *           type: string
 *           maxLength: 25
 *           example: "2020-09-01 9:00:00.000000"
 *         recordUpdatedUserID:
 *           type: integer
 *           format: int32
 *           example: 108
 */
Object.defineProperty(exports, "__esModule", { value: true });
